import * as React from "react";
import { SVGProps } from "react";

const Waves = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 294 294" {...props}>
    <path
      fill="#0055fe"
      d="M.004 147.08 147.083.002 294.16 147.08 147.083 294.158z"
    />
  </svg>
);

export default Waves;
